import classnames from 'classnames/bind'
import React from 'react'

import { ReactComponent as Arrow } from './arrow.svg'
import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface SliderArrowProps {
  className?: string
  onClick?: () => void
  right?: boolean
  disabled?: boolean
}

function SliderArrow({
  className,
  onClick,
  disabled,
  right,
}: SliderArrowProps) {
  return (
    <button
      className={cx(css.SliderArrow, className, { disabled, right })}
      onClick={onClick}>
      <Arrow className={cx(css.icon)} />
    </button>
  )
}

SliderArrow.defaultProps = {}

export default SliderArrow
